import { g as d } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as o, normalizeClass as s, createElementVNode as a } from "vue";
import { _ as c } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const p = {
  name: "DtIconPartyPopper",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = d();
  }
}, u = ["aria-label", "data-qa", "aria-hidden"], m = ["clip-path"], h = ["id"];
function f(e, t, r, _, g, l) {
  return n(), o("svg", {
    "aria-label": r.ariaLabel,
    class: s([l.iconSizeClass, "d-icon d-icon--party-popper"]),
    "data-qa": l.dataQA,
    "aria-hidden": l.ariaHidden,
    role: "img",
    "data-name": "Party Popper",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      fill: "currentColor"
    }, [...t[0] || (t[0] = [
      a("path", { d: "M1.5 1.5A.5.5 0 0 1 2 1h.005a.5.5 0 1 1 0 1H2a.5.5 0 0 1-.5-.5Zm9 2.5a.5.5 0 0 1 .5-.5h.005a.5.5 0 1 1 0 1H11a.5.5 0 0 1-.5-.5ZM7 1a.5.5 0 0 1 .5-.5h.005a.5.5 0 1 1 0 1H7.5A.5.5 0 0 1 7 1Zm3.5 9a.5.5 0 0 1 .5-.5h.005a.5.5 0 1 1 0 1H11a.5.5 0 0 1-.5-.5Zm.974-9.159a.5.5 0 0 1-.315.633l-1.12.375a.952.952 0 0 0-.643 1.022l-.496.064.497-.058A1.23 1.23 0 0 1 8.175 4.25h-.19a.39.39 0 0 0-.389.314v.003l-.106.53a.5.5 0 1 1-.98-.194l.104-.529A1.39 1.39 0 0 1 7.985 3.25h.19a.23.23 0 0 0 .229-.255A1.95 1.95 0 0 1 9.722.9l1.12-.375a.5.5 0 0 1 .632.315ZM9.108 6.803c.134-.765.94-1.22 1.666-.933l.003.001.41.165a.5.5 0 1 1-.374.928l-.408-.164a.234.234 0 0 0-.312.174A1.225 1.225 0 0 1 8.885 8H8.5a.5.5 0 1 1 0-1h.385c.11 0 .204-.082.221-.188l.002-.009ZM5.313.536a.5.5 0 0 1 .65.277l.167.413a1.234 1.234 0 0 1-.933 1.666l-.016.003a.222.222 0 0 0-.181.22V3.5a.5.5 0 1 1-1 0v-.385c0-.59.428-1.117 1.028-1.208a.234.234 0 0 0 .172-.312l-.164-.408a.5.5 0 0 1 .277-.65Zm1.204 9.04-5.35 1.895a.5.5 0 0 1-.638-.638l1.9-5.35c.033-.08.124-.257.217-.337.224-.223.514-.299.781-.3.264-.002.539.067.803.172.529.212 1.105.61 1.624 1.128.518.519.916 1.095 1.128 1.624.105.264.174.54.173.803-.002.267-.078.557-.301.78l-.337.223Zm-3.084-3.73c-.043 0-.078.01-.078.01a.251.251 0 0 0-.01.077c0 .093.026.236.102.425.15.376.46.842.907 1.288.446.447.912.757 1.288.907.189.076.332.102.425.102a.25.25 0 0 0 .078-.01.25.25 0 0 0 .01-.078 1.19 1.19 0 0 0-.102-.425c-.15-.376-.46-.842-.907-1.288-.446-.447-.912-.757-1.288-.907a1.19 1.19 0 0 0-.425-.102Zm-.602 1.492c.214.344.491.691.815 1.016.326.325.674.603 1.02.817l-2.844 1.007 1.01-2.84Z" }, null, -1)
    ])], 8, m),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, [...t[1] || (t[1] = [
        a("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, h)
    ])
  ], 10, u);
}
const H = /* @__PURE__ */ c(p, [["render", f]]);
export {
  H as default
};
//# sourceMappingURL=party-popper.js.map
